<wl-masonry-container
  [items]="masonryItems$ | async"
  [device]="deviceChange$ | async"
  [isLoading]="isLoading"
></wl-masonry-container>
@if (!isLoading) {
  <wl-pagination-by-url
    wlAutomationId="knowledge-base-pagination"
    class="d-flex justify-content-center mt-2"
    [collectionSize]="numberOfArticles$ | async"
    [rotate]="true"
    [maxSize]="{ desktop: 5, mobile: 1 }"
    [pageSize]="pageSize$ | async"
    [isXpEditor]="isXpEditor$ | async"
  ></wl-pagination-by-url>
}
